import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpResponse, HttpEvent } from '@angular/common/http';
import { getJwtToken } from '../utils';
import { tap, catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import { WatcherService } from '../watcher.service';
import { MatSnackBar } from '@angular/material';
import { ProgressiveLoaderService } from '../progressive-loader.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private watcher: WatcherService, private snackBar: MatSnackBar, private loader: ProgressiveLoaderService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        this.loader.updateLoader(true);
        const authToken = `Bearer ${getJwtToken()}`;
        const authReq = req.clone({
            headers: req.headers.set('Authorization', authToken)
        });

        return next.handle(authReq).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    switch (event.status) {
                        case 200: // Ok
                            break;
                        case 201: // Created
                            break;
                        case 202: // Accepted
                            break;
                        default:
                            break;
                    }
                }
            }), catchError(response => {
                this.snackBar.open(response.error, 'Dismiss err', {
                    duration: 5000,
                });
                if (response instanceof HttpErrorResponse) {
                    switch (response.status) {
                        case 400:
                            // this.notification.showError(errorMessage, false, 5);
                            /**
                             * Bad Request
                             */
                            break;
                        case 401:
                            /**
                             * Unauthorized
                             */
                            this.watcher.logout(true);
                            break;
                        case 403:
                            // this.notification.showError(errorMessage, false, 5);
                            break;
                        case 500:
                            /**
                             * Internal Server Error
                             */
                            break;
                        default:
                            if (response.error && response.error.validation && response.error.validation[0]) {
                                // this.notification.onError('Error', response.error.validation[0].errorMessage);
                            } else {
                                // this.notification.onError('Error', response.error.description);
                            }
                            break;
                    }
                }
                return of(response.message);
            }),
            finalize(() => {
                this.loader.updateLoader(false);
            }));
    }
}
